// Utility function for smooth scrolling to sections
export const scrollToSection = (sectionId, navigate = null, currentPath = '/') => {
  if (navigate && currentPath !== '/') {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  } else {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
};

// Utility function for scrolling to top
export const scrollToTop = (behavior = 'smooth') => {
  window.scrollTo({ top: 0, behavior });
};

// WhatsApp Business API Configuration
const WHATSAPP_CONFIG = {
  phoneNumberId: 'YOUR_PHONE_NUMBER_ID', // Get from Meta Business Manager
  accessToken: 'YOUR_ACCESS_TOKEN', // Get from Meta Developer Console
  apiVersion: 'v18.0',
  recipientNumber: '917985881438' // Your phone number to receive messages
};

// WhatsApp Business API function
export const sendWhatsAppMessage = async (formData) => {
  const { name, email, phone, message } = formData;
  
  const messageText = `🎨 New Art Inquiry from Website!\n\n` +
    `👤 Name: ${name}\n` +
    `📧 Email: ${email}\n` +
    `📱 Phone: ${phone}\n\n` +
    `💬 Message:\n${message}\n\n` +
    `⏰ Received: ${new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })}`;

  const apiUrl = `https://graph.facebook.com/${WHATSAPP_CONFIG.apiVersion}/${WHATSAPP_CONFIG.phoneNumberId}/messages`;
  
  const payload = {
    messaging_product: 'whatsapp',
    to: WHATSAPP_CONFIG.recipientNumber,
    type: 'text',
    text: {
      body: messageText
    }
  };

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${WHATSAPP_CONFIG.accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (response.ok) {
      const result = await response.json();
      console.log('WhatsApp message sent successfully:', result);
      return { success: true, message: 'Message sent successfully!' };
    } else {
      const error = await response.json();
      console.error('WhatsApp API Error:', error);
      throw new Error(error.error?.message || 'Failed to send message');
    }
  } catch (error) {
    console.error('Error sending WhatsApp message:', error);
    return { success: false, message: 'Failed to send message. Please try again.' };
  }
};

// Fallback to WhatsApp Web (current method)
export const openWhatsApp = (formData) => {
  const { name, email, phone, message } = formData;
  const whatsappMessage = `Hello! I'm interested in your art services.%0A%0AName: ${name}%0AEmail: ${email}%0APhone: ${phone}%0AMessage: ${message}`;
  const whatsappURL = `https://wa.me/917985881438?text=${whatsappMessage}`;
  window.open(whatsappURL, '_blank');
};
